import Vue from 'vue';
import ApplicationLayout from '@/layouts/ApplicationLayout.vue';
import EmptyLayout from '@/layouts/EmptyLayout.vue';

Vue.component('ApplicationLayout', ApplicationLayout);
Vue.component('EmptyLayout', EmptyLayout);
